

import React from 'react';
import { Col, thc } from '@flightstats/airframe-react';
import styled from 'styled-components';

const StyledCol = styled.div`
  flex: unset;
  border-style: solid;
  border-color: darkgrey;
  padding: 8px;
  display: flex;
  flex-direction: column;
  `;

interface BoxOutlinedGroupedComponentsProps {
  header: string;
  children: React.ReactNode;
}

export const BoxOutlinedGroupedComponents: React.FC<BoxOutlinedGroupedComponentsProps> = ({
  header,
  children,
}) => (
  <>
    <StyledCol>
      <h5 style={{ margin: '0 0 3px 5px' }}>{header}</h5>
      {children}
    </StyledCol>
  </>
);
